import React from 'react';
import { SIZE_OPTIONS } from '../companySize';
import './SizeFilter.css';

/* Company-size toggles for the sidebar. Nothing selected = every size. */
const SizeFilter = ({ value = [], onChange }) => {
    const toggle = (key) =>
        onChange(value.includes(key) ? value.filter((k) => k !== key) : [...value, key]);
    return (
        <div className="size-filter" role="group" aria-label="Company size">
            {SIZE_OPTIONS.map((o) => (
                <button
                    key={o.key}
                    type="button"
                    title={o.hint}
                    aria-pressed={value.includes(o.key)}
                    className={value.includes(o.key) ? 'on' : ''}
                    onClick={() => toggle(o.key)}
                >
                    {o.label}
                </button>
            ))}
        </div>
    );
};

export default SizeFilter;
